import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export async function listSchools() {
  const res = await axios.get(`${API}/schools`);
  return res.data;
}

export async function getSchool(id) {
  const res = await axios.get(`${API}/schools/${id}`);
  return res.data;
}

export async function saveSchool({ id, state }) {
  const res = await axios.post(`${API}/schools`, { id, state });
  return res.data;
}

export async function deleteSchool(id) {
  const res = await axios.delete(`${API}/schools/${id}`);
  return res.data;
}
